import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useContext } from 'react';
import classnames from 'classnames';
import Week from './panel/week/week';
import Context from './context';
import { getStartOfWeek, getStartOfMonth, addWeeks, addDays, getWeekdayShortInLocale, getWeekdayMinInLocale } from './utils/date-fns';
var DATE_ROW_COUNT = 6;

function Calendar(props) {
  var context = useContext(Context);
  var prefixCls = context.prefixCls,
      viewDate = context.viewDate;
  var picker = props.picker,
      useWeekdaysShort = props.useWeekdaysShort,
      showWeekNumber = props.showWeekNumber,
      showWeeksTitle = props.showWeeksTitle,
      showTime = props.showTime,
      disabledDate = props.disabledDate; // const isWeekInMonth = (startOfWeek: DateType) => {
  //   const endOfWeek = addDays(startOfWeek, 6)
  //   return isSameMonth(startOfWeek, viewDate) || isSameMonth(endOfWeek, viewDate)
  // }
  // 获取title部分 周的格式

  var formatWeekday = function formatWeekday(day) {
    return useWeekdaysShort ? getWeekdayShortInLocale(day) : getWeekdayMinInLocale(day);
  }; // const getEffectTime = () => {
  // }


  var renderWeeksTitle = function renderWeeksTitle() {
    var _context;

    var startOfWeek = getStartOfWeek(viewDate);
    var dayNames = [];
    var weekTitleCls = classnames("".concat(prefixCls, "-weektitle"));
    var weekTitleItemCls = classnames("".concat(prefixCls, "-weektitle-item"));

    if (showWeekNumber) {
      var weekTitleNumberItemCls = classnames("".concat(prefixCls, "-weektitle-weeknumber"));
      dayNames.push( /*#__PURE__*/React.createElement("div", {
        key: "W",
        className: weekTitleNumberItemCls
      }));
    }

    return /*#__PURE__*/React.createElement("div", {
      className: weekTitleCls
    }, _concatInstanceProperty(dayNames).call(dayNames, _mapInstanceProperty(_context = [0, 1, 2, 3, 4, 5, 6]).call(_context, function (offset) {
      var day = addDays(startOfWeek, offset);
      var weekDayName = formatWeekday(day);
      return /*#__PURE__*/React.createElement("div", {
        key: offset,
        className: weekTitleItemCls
      }, weekDayName);
    })));
  };

  var renderWeeks = function renderWeeks() {
    var currentWeekStart = getStartOfWeek(getStartOfMonth(viewDate));
    var weeks = [];
    var i = 0;

    while (true) {
      weeks.push( /*#__PURE__*/React.createElement(Week, {
        key: i,
        day: currentWeekStart,
        picker: picker,
        showWeekNumber: showWeekNumber,
        showTime: !!showTime,
        disabledDate: disabledDate
      }));
      i++;
      currentWeekStart = addWeeks(currentWeekStart, 1); // 最少保证面板包含有六周，保证左右面板及切换面板时周数一致

      if (i >= DATE_ROW_COUNT) {
        break;
      } // const isNonFixedAndOutOfMonth = !isWeekInMonth(currentWeekStart)
      // if (panelPosition) {
      //   // range 模式时，最少保证面板包含有六周，保证左右面板周数一致
      //   if (i >= DATE_ROW_COUNT) {
      //     break
      //   }
      // } else {
      //   if (isNonFixedAndOutOfMonth) {
      //     break
      //   }
      // }

    }

    return weeks;
  };

  var calendarCls = classnames("".concat(prefixCls, "-calendar"));
  var calendarWarpperCls = classnames("".concat(prefixCls, "-calendar-warpper")); // let _showWeeksTitle
  // if (picker === 'date' || picker === 'week') {
  //   _showWeeksTitle = showWeeksTitle
  // }

  return /*#__PURE__*/React.createElement("div", {
    className: calendarCls
  }, showWeeksTitle ? renderWeeksTitle() : null, /*#__PURE__*/React.createElement("div", {
    className: calendarWarpperCls
  }, renderWeeks()));
}

export default Calendar;